import { cn } from '@nucleus-commerce/ui/lib/utils';

function tone(status: number): string {
  if (status >= 500) return 'bg-destructive/10 text-destructive border-destructive/25';
  if (status >= 400)
    return 'bg-warning/15 text-warning-foreground border-warning/40 dark:text-warning';
  if (status >= 300) return 'bg-info/10 text-info border-info/25';
  return 'bg-success/10 text-success border-success/25';
}

/** HTTP status chip, coloured by class (2xx, 3xx, 4xx, 5xx). */
export function StatusCode({ status, className }: { status: string; className?: string }) {
  return (
    <span
      data-status={status}
      className={cn(
        'inline-flex h-5 items-center rounded border px-1.5 font-mono text-[11px] font-semibold',
        tone(Number(status)),
        className,
      )}
    >
      {status}
    </span>
  );
}
